<div class="ibox detailed-view-ibox" *ngIf="directoryService.showDetailedView && data">
    <div class="detailed-view-header">
        <span class="close-detailed-view" (click)="directoryService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body" [ngClass]="{'no-action-button': actionButtonIsNotAvailable()}">
        <div class="detailed-view__more-info directory-detailed-view-content m-t-md" [ngClass]="{'no-action-button': actionButtonIsNotAvailable()}">
            <form #form="ngForm" [ngClass]="{'ng-submitted': form.submitted}">
                <input type="hidden" name="id" [ngModel]="data.id">

                <div class="display-flex m-b-sm">
                    <div class="vendor-avatar">
                        <input type="file"
                               name="attachment"
                               accept=".gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff"
                               id="add-attachment-btn"
                               (change)="addFile($event)"
                               [disabled]="disabledFileInput"
                               hidden>
                        <img [src]="data.logo || 'assets/img/placeholder.png'"
                             (click)="data.isCanEdit && clickFileUploadButton()">
                        <i *ngIf="data.isCanEdit"
                           class="fa fa-trash"
                           (click)="removeLogo()"
                           title="Delete Attachment">
                        </i>
                        <spinner [spinnerShow]="spinnerShow"></spinner>
                    </div>

                    <div>
                        <!--<div class="rating-row">-->
                            <!--<i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>-->
                            <!--<i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>-->
                            <!--<i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>-->
                            <!--<i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>-->
                            <!--<i class="fa fa-star-o m-r-sm" aria-hidden="true"></i>-->
                            <!--22-->
                            <!--<span class="m-l-md" *ngIf="data.verified">-->
                                <!--<i class="fa fa-2x fa-shield mtv-primary-color" aria-hidden="true"></i>-->
                            <!--</span>-->
                        <!--</div>-->
                        <h2 class="bold">{{data.name}}</h2>
                        <div class="address-row" *ngFor="let address of data.addresses; let first = first;">
                            <i [ngStyle]="{'visibility' : !first ? 'hidden' : 'visible'}" class="fa fa-2x fa-map-marker m-r-sm" aria-hidden="true"></i>
                            <div class="address">{{getItemAddressString(address)}}</div>
                            <!--<span>-->
                                <!--<span class="mtv-primary-color">Map</span>-->
                            <!--</span>-->
                        </div>
                        <div class="contacts-row" *ngFor="let phone of data.phones; let first = first;">
                            <i [ngStyle]="{'visibility' : !first ? 'hidden' : 'visible'}" class="fa fa-phone" aria-hidden="true"></i>
                            <span class="m-r-md">{{phone.phone}}</span>
                            <!--<i class="fa fa-globe" aria-hidden="true"></i>-->
                            <!--<span class="mtv-primary-color">Website</span>-->
                        </div>
                    </div>
                </div>
                <div class="m-b-sm" *ngIf="data.serviceAreas.length > 0">
                    Service Areas:
                    <span *ngFor="let service of data.serviceAreas; let last = last;">
                        {{service.name}}{{!last ? ', ' : ''}}
                    </span>
                </div>
                <div class="m-b-sm" *ngIf="data.serviceAreas.length < 1">
                    No Service Areas
                </div>
                <!--<div class="vendor-buttons" [ngClass]="{'admin-view': userIsSuperAdmin()}">-->
                    <!--&lt;!&ndash;<button class="btn btn-primary">&ndash;&gt;-->
                        <!--&lt;!&ndash;Get a Quote&ndash;&gt;-->
                    <!--&lt;!&ndash;</button>&ndash;&gt;-->
                    <!--<button class="btn btn-outer-primary mtv-primary-color mtv-primary-border">-->
                        <!--Leave a Review-->
                    <!--</button>-->
                    <!--<button *ngIf="!userIsSuperAdmin()"-->
                            <!--(click)="addToFavorites()"-->
                            <!--class="btn btn-outer-primary mtv-primary-color mtv-primary-border">-->
                        <!--<i *ngIf="!data.userCompany || !data.userCompany.favorite" class="fa fa-heart-o" aria-hidden="true"></i>-->
                        <!--<i *ngIf="data.userCompany && data.userCompany.favorite" class="fa fa-heart" aria-hidden="true"></i>-->
                    <!--</button>-->
                <!--</div>-->

                <!--<div class="m-t-sm m-b-sm">-->
                    <!--<div>-->
                        <!--<span class="bold">22 Reviews</span>-->
                        <!--<span class="pull-right">-->
                            <!--<i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>-->
                            <!--<i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>-->
                            <!--<i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>-->
                            <!--<i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>-->
                            <!--<i class="fa fa-star-o m-r-sm" aria-hidden="true"></i>-->
                        <!--</span>-->
                    <!--</div>-->
                    <!--<div class="row">-->
                        <!--<div class="col-md-4">Average Rating</div>-->
                        <!--<div class="col-md-8">-->
                            <!--<mat-progress-bar class="m-t-sm" mode="determinate" [value]="100"></mat-progress-bar>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="row">-->
                        <!--<div class="col-md-4">Recency</div>-->
                        <!--<div class="col-md-8">-->
                            <!--<mat-progress-bar class="m-t-sm" mode="determinate" [value]="70"></mat-progress-bar>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="row">-->
                        <!--<div class="col-md-4">Reputation</div>-->
                        <!--<div class="col-md-8">-->
                            <!--<mat-progress-bar class="m-t-sm" mode="determinate" [value]="70"></mat-progress-bar>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="row">-->
                        <!--<div class="col-md-4">Responsiveness</div>-->
                        <!--<div class="col-md-8">-->
                            <!--<mat-progress-bar class="m-t-sm" mode="determinate" [value]="70"></mat-progress-bar>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->

                <div class="detailed-view-navigation m-t-sm m-b-md">
                    <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <div class="button-section" (click)="changeNavPosition('profile')"
                             [ngStyle]="{'background-color': navPosition == 'profile' ? '#ebebeb' : ''}">Profile</div>
                    </div>
                    <!--<div class="col-md-4 col-sm-4 col-xs-4 no-padding">-->
                        <!--<div class="button-section" (click)="changeNavPosition('reviews')"-->
                             <!--[ngStyle]="{'background-color': navPosition == 'reviews' ? '#ebebeb' : ''}">Reviews</div>-->
                    <!--</div>-->
                    <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <div class="button-section" (click)="changeNavPosition('photos')"
                             [ngStyle]="{'background-color': navPosition == 'photos' ? '#ebebeb' : ''}">Photos</div>
                    </div>
                </div>

                <div *ngIf="navPosition == 'profile'">
                    <input type="hidden" name="id" [ngModel]="data.id">

                    <!--** Corporations ** -->
                    <div class="row m-b-xs clickable" (dblclick)="data.isCanEdit && setEditModeFor(data, 'corporations', true)">
                        <div class="dv-label col-md-4 strong">Corporations</div>
                        <div class="col-md-8 display-flex" *ngIf="!data.formFields.corporations.editMode">
                            <span *ngIf="data.corporations.length < 1">-</span>
                            <div class="m-r-md" style="width: 220px;">
                                <multiselect-field *ngIf="data.corporations.length > 0"
                                                   name="corporations"
                                                   [data]="directoryService.corporations"
                                                   [noEdit]="true"
                                                   [(ngModel)]="data.corporations">
                                </multiselect-field>
                            </div>
                            <div (click)="setEditModeFor(data, 'corporations', true)" *ngIf="data.isCanEdit">
                                <i class="fa fa-pencil pull-right m-t-xs"
                                   data-toggle="tooltip" data-placement="top" title="Edit"></i>
                            </div>
                        </div>
                        <div *ngIf="data.formFields.corporations.editMode" class="col-md-6">
                            <angular2-multiselect name="corporations"
                                                  [data]="directoryService.corporations"
                                                  [(ngModel)]="data.corporations"
                                                  [settings]="categoriesMultiselectSettings">
                            </angular2-multiselect>
                        </div>
                        <div *ngIf="data.formFields.corporations.editMode"
                             style="padding: 0;"
                             class="col-sm-2 m-t-xs apart-btns pull-right">
                            <button type="button" class="apply" (click)="applyChanges(data, form, 'corporations')">
                                <i class="fa fa-check"></i>
                            </button>

                            <button type="button" class="reset" (click)="setEditModeFor(data, 'corporations', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--** Services ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && setEditModeFor(data, 'services', true)">
                        <div class="dv-label col-sm-4 strong">Services</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.services.editMode">
                            <pre>{{data.services || '-'}}</pre>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'services', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value col-sm-8" *ngIf="data.formFields.services.editMode">
                            <textarea class="form-control" name="services" [ngModel]="data.services" maxlength="255">
                                {{data.services}}
                            </textarea>
                            <div class="m-t-xs apart-btns pull-right">
                                <button type="button" class="apply" (click)="applyChanges(data, form, 'services')"><i
                                    class="fa fa-check"></i></button>
                                <button type="button" class="reset" (click)="setEditModeFor(data, 'services', false)"><i
                                    class="fa fa-times"></i></button>
                            </div>
                        </div>
                    </div>

                    <!--** Products ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && editProductChanges()">
                        <div class="dv-label col-sm-4 strong">Products</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.products.editMode">
                            <div *ngIf="data.products.length > 0">
                                <span *ngFor="let product of data.products; let last = last;">
                                    {{product}}{{!last ? ', ' : ''}}
                                </span>
                            </div>
                            <div *ngIf="data.products.length < 1">-</div>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="editProductChanges()"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value col-sm-8" *ngIf="data.formFields.products.editMode">
                            <div class="row m-b-sm" *ngFor="let val of data.products; trackBy: trackByFn; let index = index;">
                                <div class="dv-value-edit col-sm-12 products-row">
                                    <input class="form-control"
                                           [(ngModel)]="data.products[index]"
                                           name="input{{index}}"
                                           maxlength="255">
                                    <button type="button" (click)="addNewProduct(index)">
                                        <i class="fa icon-plus" title="Add"></i>
                                    </button>
                                    <button type="button" (click)="removeProduct(index)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="m-t-xs apart-btns pull-right">
                                <button type="button" class="apply" (click)="submitProductsChanges()">
                                    <i class="fa fa-check"></i>
                                </button>
                                <button type="button" class="reset" (click)="revertProductsChanges()">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                            <div *ngIf="data.products.length < 1" class="m-t-xs apart-btns pull-right">
                                <button type="button" class="apply add-product" (click)="addNewProduct(index)">
                                    <i class="fa icon-plus"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!--** Categories ** -->
                    <div class="row m-b-xs clickable" (dblclick)="data.isCanEdit && setEditModeFor(data, 'categories', true)">
                        <div class="dv-label col-md-4 strong">Categories</div>
                        <div class="col-md-8 display-flex" *ngIf="!data.formFields.categories.editMode">
                            <span *ngIf="data.categories.length < 1">-</span>
                            <div class="m-r-md" style="width: 220px;">
                                <multiselect-field *ngIf="data.categories.length > 0"
                                                   name="categories"
                                                   [data]="categories"
                                                   [noEdit]="true"
                                                   [(ngModel)]="data.categories">
                                </multiselect-field>
                            </div>
                            <div (click)="setEditModeFor(data, 'categories', true)" *ngIf="data.isCanEdit">
                                <i class="fa fa-pencil pull-right m-t-xs"
                                   data-toggle="tooltip" data-placement="top" title="Edit"></i>
                            </div>
                        </div>
                        <div *ngIf="data.formFields.categories.editMode" class="col-md-6">
                            <angular2-multiselect name="categories"
                                                  [data]="categories"
                                                  [(ngModel)]="data.categories"
                                                  [settings]="categoriesMultiselectSettings">
                            </angular2-multiselect>
                        </div>
                        <div *ngIf="data.formFields.categories.editMode"
                             style="padding: 0;"
                             class="col-sm-2 m-t-xs apart-btns pull-right">
                            <button type="button" class="apply" (click)="applyChanges(data, form, 'categories')">
                                <i class="fa fa-check"></i>
                            </button>

                            <button type="button" class="reset" (click)="setEditModeFor(data, 'categories', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--** Lists ** -->
                    <div class="row m-b-xs clickable">
                        <div class="dv-label col-md-4 strong">Lists</div>
                        <div class="col-md-8" *ngIf="!data.formFields.categories.editMode">
                            <list-with-hint [listItems]="data.corporationsAndLists"
                                            [property]="'name'"
                                            [parentElementSelector]="'.clickable'">
                            </list-with-hint>
                        </div>
                    </div>

                    <!--** Year Established ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && setEditModeFor(data, 'yearEstablished', true)">
                        <div class="dv-label col-sm-4 strong">Year Established</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.yearEstablished.editMode">
                            <span>{{data.yearEstablished || '-'}}</span>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'yearEstablished', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.yearEstablished.editMode">
                            <input class="form-control"
                                   name="yearEstablished"
                                   [ngModel]="data.yearEstablished"
                                   maxlength="4"
                                   pattern="[0-9]+"
                                   (keypress)="validateForNumberInput($event)"
                                   (keyup.enter)="applyChanges(data, form, 'yearEstablished')">
                            <button type="button" (click)="applyChanges(data, form, 'yearEstablished')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(data, 'yearEstablished', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--** # of Employees ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && setEditModeFor(data, 'numberOfEmployees', true)">
                        <div class="dv-label col-sm-4 strong"># of Employees</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.numberOfEmployees.editMode">
                            <span>{{data.minNumberOfEmployees && data.maxNumberOfEmployees ? (data.minNumberOfEmployees + ' - ' + data.maxNumberOfEmployees) : '-'}}</span>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'numberOfEmployees', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.numberOfEmployees.editMode">
                            <input class="form-control"
                                   name="minNumberOfEmployees"
                                   [ngModel]="data.minNumberOfEmployees"
                                   maxlength="4"
                                   pattern="[0-9]+"
                                   (keypress)="validateForNumberInput($event)"
                                   (keyup.enter)="applyChanges(data, form, 'numberOfEmployees')">
                            <span class="m-l-sm m-r-sm m-t-xs">-</span>
                            <input class="form-control"
                                   name="maxNumberOfEmployees"
                                   [ngModel]="data.maxNumberOfEmployees"
                                   maxlength="4"
                                   pattern="[0-9]+"
                                   (keypress)="validateForNumberInput($event)"
                                   (keyup.enter)="applyChanges(data, form, 'numberOfEmployees')">
                            <button type="button" (click)="applyChanges(data, form, 'numberOfEmployees')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(data, 'numberOfEmployees', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--** Return Policy ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && setEditModeFor(data, 'returnPolicy', true)">
                        <div class="dv-label col-sm-4 strong">Return Policy</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.returnPolicy.editMode">
                            <span>{{data.returnPolicy || '-'}}</span>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'returnPolicy', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.returnPolicy.editMode">
                            <input class="form-control" name="returnPolicy" [ngModel]="data.returnPolicy" maxlength="255"
                                   (keyup.enter)="applyChanges(data, form, 'returnPolicy')">
                            <button type="button" (click)="applyChanges(data, form, 'returnPolicy')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(data, 'returnPolicy', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--** Payment Method ** -->
                    <div class="row m-b-xs clickable" (dblclick)="data.isCanEdit && setEditModeFor(data, 'paymentMethods', true)">
                        <div class="dv-label col-md-4 strong">Payment Method</div>
                        <div class="col-md-8 display-flex" *ngIf="!data.formFields.paymentMethods.editMode">
                            <span *ngIf="data.paymentMethods.length < 1">-</span>
                            <div class="m-r-md" style="width: 220px;">
                                <multiselect-field *ngIf="data.paymentMethods.length > 0"
                                                   name="paymentMethods"
                                                   [data]="paymentMethods"
                                                   [noEdit]="true"
                                                   [(ngModel)]="data.paymentMethods">
                                </multiselect-field>
                            </div>
                            <div (click)="setEditModeFor(data, 'paymentMethods', true)" *ngIf="data.isCanEdit">
                                <i class="fa fa-pencil pull-right m-t-xs"
                                   data-toggle="tooltip" data-placement="top" title="Edit"></i>
                            </div>
                        </div>
                        <div *ngIf="data.formFields.paymentMethods.editMode" class="col-md-6">
                            <angular2-multiselect name="paymentMethods"
                                                  [data]="paymentMethods"
                                                  [(ngModel)]="data.paymentMethods"
                                                  [settings]="multiselectSettings">
                            </angular2-multiselect>
                        </div>
                        <div *ngIf="data.formFields.paymentMethods.editMode"
                             style="padding: 0;"
                             class="col-sm-2 m-t-xs apart-btns pull-right">
                            <button type="button" class="apply" (click)="applyChanges(data, form, 'paymentMethods')">
                                <i class="fa fa-check"></i>
                            </button>

                            <button type="button" class="reset" (click)="setEditModeFor(data, 'paymentMethods', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--** Licences ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && setEditModeFor(data, 'licences', true)">
                        <div class="dv-label col-sm-4 strong">Licences</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.licences.editMode">
                            <span>{{data.licences || '-'}}</span>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'licences', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.licences.editMode">
                            <input class="form-control" name="licences" [ngModel]="data.licences" maxlength="255"
                                   (keyup.enter)="applyChanges(data, form, 'licences')">
                            <button type="button" (click)="applyChanges(data, form, 'licences')"><i class="fa fa-check"></i></button>
                            <button type="button" (click)="setEditModeFor(data, 'licences', false)"><i class="fa fa-times"></i></button>
                        </div>
                    </div>

                    <!--** Membership ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && setEditModeFor(data, 'membership', true)">
                        <div class="dv-label col-sm-4 strong">Membership</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.membership.editMode">
                            <span>{{data.membership || '-'}}</span>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'membership', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.membership.editMode">
                            <input class="form-control" name="membership" [ngModel]="data.membership" maxlength="255"
                                   (keyup.enter)="applyChanges(data, form, 'membership')">
                            <button type="button" (click)="applyChanges(data, form, 'membership')"><i class="fa fa-check"></i></button>
                            <button type="button" (click)="setEditModeFor(data, 'membership', false)"><i class="fa fa-times"></i></button>
                        </div>
                    </div>

                    <!--** Liability Insurance ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && setEditModeFor(data, 'liabilityInsurance', true)">
                        <div class="dv-label col-sm-4 strong">Liability Insurance</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.liabilityInsurance.editMode">
                            <i *ngIf="data.liabilityInsurance" class="icon-check"></i>
                            <i *ngIf="!data.liabilityInsurance" class="icon-close"></i>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(data, 'liabilityInsurance', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.liabilityInsurance.editMode">
                            <select class="form-control" name="liabilityInsurance" [ngModel]="data.liabilityInsurance">
                                <option [ngValue]="true">Yes</option>
                                <option [ngValue]="false">No</option>
                            </select>
                            <button type="button" (click)="applyChanges(data, form, 'liabilityInsurance')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(data, 'liabilityInsurance', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--** Workers Comp. ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && setEditModeFor(data, 'workersCompensation', true)">
                        <div class="dv-label col-sm-4 strong">Workers Comp.</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.workersCompensation.editMode">
                            <i *ngIf="data.workersCompensation" class="icon-check"></i>
                            <i *ngIf="!data.workersCompensation" class="icon-close"></i>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(data, 'workersCompensation', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.workersCompensation.editMode">
                            <select class="form-control" name="workersCompensation" [ngModel]="data.workersCompensation">
                                <option [ngValue]="true">Yes</option>
                                <option [ngValue]="false">No</option>
                            </select>
                            <button type="button" (click)="applyChanges(data, form, 'workersCompensation')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(data, 'workersCompensation', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--** Bonded ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && setEditModeFor(data, 'bonded', true)">
                        <div class="dv-label col-sm-4 strong">Bonded</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.bonded.editMode">
                            <i *ngIf="data.bonded" class="icon-check"></i>
                            <i *ngIf="!data.bonded" class="icon-close"></i>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(data, 'bonded', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.bonded.editMode">
                            <select class="form-control" name="bonded" [ngModel]="data.bonded">
                                <option [ngValue]="true">Yes</option>
                                <option [ngValue]="false">No</option>
                            </select>
                            <button type="button" (click)="applyChanges(data, form, 'bonded')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(data, 'bonded', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--** Written Contact ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && setEditModeFor(data, 'writtenContract', true)">
                        <div class="dv-label col-sm-4 strong">Written Contract</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.writtenContract.editMode">
                            <i *ngIf="data.writtenContract" class="icon-check"></i>
                            <i *ngIf="!data.writtenContract" class="icon-close"></i>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(data, 'writtenContract', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.writtenContract.editMode">
                            <select class="form-control" name="writtenContract" [ngModel]="data.writtenContract">
                                <option [ngValue]="true">Yes</option>
                                <option [ngValue]="false">No</option>
                            </select>
                            <button type="button" (click)="applyChanges(data, form, 'writtenContract')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(data, 'writtenContract', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--** WARRANTY TERMS ** -->
                    <div class="row m-b-xs" (dblclick)="data.isCanEdit && setEditModeFor(data, 'warrantyTerms', true)">
                        <div class="dv-label col-sm-4 strong">Warranty Terms</div>
                        <div class="dv-value col-sm-8" *ngIf="!data.formFields.warrantyTerms.editMode">
                            <pre>{{data.warrantyTerms || '-'}}</pre>
                            <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(data, 'warrantyTerms', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value col-sm-8" *ngIf="data.formFields.warrantyTerms.editMode">
                            <textarea class="form-control" name="warrantyTerms" [ngModel]="data.warrantyTerms" maxlength="255">
                                {{data.warrantyTerms}}
                            </textarea>
                            <div class="m-t-xs apart-btns pull-right">
                                <button type="button" class="apply" (click)="applyChanges(data, form, 'warrantyTerms')">
                                    <i class="fa fa-check"></i>
                                </button>
                                <button type="button" class="reset" (click)="setEditModeFor(data, 'warrantyTerms', false)">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!--  ** Sponsored From **  -->
                    <datetime-field
                        [ngModel]="data.sponsoredFrom"
                        name="sponsoredFrom"
                        [title]="'Sponsored From'"
                        (update)="applyChangesForDate(data, form, 'sponsoredFrom')"
                        [noEdit]="!userIsSuperAdmin()">
                    </datetime-field>

                    <!--  ** Sponsored То **  -->
                    <datetime-field
                        [ngModel]="data.sponsoredTo"
                        [value]="data.sponsoredTo"
                        name="sponsoredTo"
                        [title]="'Sponsored To'"
                        (update)="applyChangesForDate(data, form, 'sponsoredTo')"
                        [noEdit]="!userIsSuperAdmin()">
                    </datetime-field>

                </div>
                <div *ngIf="navPosition == 'reviews'">
                    <div>
                        <span class="bold">22 Reviews</span>
                        <span class="pull-right">
                            <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                            <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                            <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                            <i class="fa fa-star mtv-primary-color" aria-hidden="true"></i>
                            <i class="fa fa-star-o m-r-sm" aria-hidden="true"></i>
                        </span>
                    </div>
                    <div class="row">
                        <div class="col-md-4">Average Rating</div>
                        <div class="col-md-8">
                            <mat-progress-bar class="m-t-sm" mode="determinate" [value]="100"></mat-progress-bar>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">Recency</div>
                        <div class="col-md-8">
                            <mat-progress-bar class="m-t-sm" mode="determinate" [value]="70"></mat-progress-bar>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">Reputation</div>
                        <div class="col-md-8">
                            <mat-progress-bar class="m-t-sm" mode="determinate" [value]="70"></mat-progress-bar>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">Responsiveness</div>
                        <div class="col-md-8">
                            <mat-progress-bar class="m-t-sm" mode="determinate" [value]="70"></mat-progress-bar>
                        </div>
                    </div>

                    <hr>
                </div>
                <div *ngIf="navPosition == 'photos'">
                    <ul class="photo-list">
                        <li *ngFor="let photo of data.photos">
                            <img [src]="photo.url">
                        </li>
                    </ul>
                </div>
            </form>
        </div>

        <hr *ngIf="data.id && data.isCanDelete">

        <div class="btn-group dropup directory-actions" *ngIf="data.id && data.isCanDelete">
            <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                Actions <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
                <li (click)="remove(data.id)"><a>Delete This {{title}}</a></li>
            </ul>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/detailed-view/vendor-view/vendor-view.component.html